import { Box, List, ListItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { LocalizedString } from 'app/models/ActiveMinutes'

interface HealthResourceData {
  id: string
  displayName: LocalizedString
  healthResourceType: string
  type?: string
}

interface Props {
  healthResourcesData: HealthResourceData[]
  collapsed: boolean
}

export const PlanHealthResource = ({ healthResourcesData, collapsed }: Props) => {
  const {
    t,
    i18n: { resolvedLanguage = 'en' },
  } = useTranslation()

  const getLocalizedName = ({ displayName }: HealthResourceData): string => {
    return displayName[resolvedLanguage as keyof LocalizedString] || displayName.en
  }

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="body2">
        {t('planCard.healthResourcesAmount', { count: healthResourcesData.length })}
      </Typography>
      {!collapsed && (
        <List
          sx={{
            listStyleType: 'disc',
            pl: 3,
            pt: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
            },
          }}
        >
          {healthResourcesData.map((resource: HealthResourceData, index: number) => (
            <ListItem key={`${resource.displayName.en}-${index}`} sx={{ pl: 0, py: 0 }}>
              <Typography variant="body2">{getLocalizedName(resource)}</Typography>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}
